import { FC, useEffect, useState } from 'react'
import {
  FadeInContent,
  MenuExpandableAnchor,
  StyledMenu,
} from 'components/menu/menu.styles'
import AnimateHeight from 'react-animate-height'
import { ThemeVariant } from 'types'
import { Anchor, Box, Button, Hidden, Icon, Text } from 'ui/core'
import { Account } from 'types/account'
import axios from 'axios'

interface Props {
  theme: ThemeVariant
  accounts: Account[] | null
  userName: string
  open: boolean
  accountsLoading: boolean
}
export const MobileHeaderLoginMenu: FC<Props> = ({
  theme,
  accounts,
  userName,
  open,
  accountsLoading,
}) => {
  const [height, setHeight] = useState<string | number>(0)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!open && height !== 0) setHeight(0)
    else if (open && height === 0) setHeight('auto')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const logout = async () => {
    setLoading(true)
    axios.post(`/webapi/account/logout`).then(() => {
      window.location.reload()
      setLoading(false)
    })
  }

  const switchAccount = async (selectedAccount: string) => {
    setLoading(true)
    axios
      .post(`/webapi/account`, { selectedAccount })
      .then(() => {
        window.location.reload()
        setLoading(false)
      })
  }

  return (
    <StyledMenu
      position="absolute"
      top={0}
      left={0}
      zIndex="-1"
      width="full"
      bg="white"
      boxShadow="menu"
      autoFocus={open ? true : false}
    >
      <AnimateHeight duration={400} height={height}>
        <Box
          width="full"
          height="viewportHeight"
          overflow="scroll"
          display="flex"
          flexWrap="nowrap"
          justifyContent="flex-start"
          alignItems="stretch"
          position="relative"
        >
          <FadeInContent
            width="full"
            display="flex"
            flexDirection="column"
            flexWrap="wrap"
            height="viewportHeight"
          >
            <Box
              width="full"
              justifyContent="space-between"
              pt={6}
              pb={2}
              px={2}
            >
							<Box py={3} my={2} borderTop="light" borderBottom="light">
                <Box width="full" display="flex" justifyContent="center">
                  <Text
                    mb={0}
                    variant="textIntro"
                    color="primary300"
                    fontWeight="medium"
                  >
                    Innskráning
                  </Text>
                </Box>
              </Box>
              <MenuExpandableAnchor pt={8} href="https://vidskiptavefur.husa.is/enterhusa" >
                <Box width="full" display="flex">
                  <Box
                    width="full"
                    flexGrow={1}
                    p={2}
                    alignItems="center"
                    display="flex"
                  >
										<Icon type="shoppingBag" color="primary300" size="18" />
                    <Text
                      mb={0}
											ml={1}
                      variant="textIntro"
                      color="dark500"
                      fontWeight="medium"
                    >
                      Vefverslun
                    </Text>
                  </Box>
                </Box>
              </MenuExpandableAnchor>
              <MenuExpandableAnchor pt={8} href="https://vidskiptavefur.husa.is/" >
                <Box width="full" display="flex">
                  <Box
                    width="full"
                    flexGrow={1}
                    p={2}
                    alignItems="center"
                    display="flex"
                  >
										<Icon type="userCheck" color="primary300" size="18" />
                    <Text
                      mb={0}
											ml={1}
                      variant="textIntro"
                      color="dark500"
                      fontWeight="medium"
                    >
                      Þjónustuvefur
                    </Text>
                  </Box>
                </Box>
              </MenuExpandableAnchor>
              
            </Box>
          </FadeInContent>
        </Box>
      </AnimateHeight>
    </StyledMenu>
  )
}
